var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentDirectoryMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74996 13H16.25M9.74996 17.3333H16.25M18.4166 22.75H7.58329C7.00866 22.75 6.45756 22.5217 6.05123 22.1154C5.6449 21.7091 5.41663 21.158 5.41663 20.5833V5.41667C5.41663 4.84203 5.6449 4.29093 6.05123 3.8846C6.45756 3.47827 7.00866 3.25 7.58329 3.25H13.6348C13.9221 3.25006 14.1976 3.36424 14.4007 3.56742L20.2659 9.43258C20.4691 9.6357 20.5832 9.91121 20.5833 10.1985V20.5833C20.5833 21.158 20.355 21.7091 19.9487 22.1154C19.5424 22.5217 18.9913 22.75 18.4166 22.75Z",
    stroke: "#747577",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentDirectoryMenu);
export default __webpack_public_path__ + "static/media/studentDirectoryMenu.c28c5cd2c26b62dbae82d63854c73c35.svg";
export { ForwardRef as ReactComponent };